var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zy-img-gif",style:(_vm.fStyle || { width: `${_vm.size}px`, height: `${_vm.size}px` })},[_c('img',{attrs:{"src":_vm.imgList[_vm.index]}}),_c('div',{staticClass:"zy-img-gif-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }